import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "btn_text" }




export default /*@__PURE__*/_defineComponent({
  __name: 'primaryButton',
  props: {
    icon: {
        type: String,
        default: () => ''
    },
    text: {
        type: String,
        default: () => ''
    },
    textColor: {
        type: String,
        default: () => '#fff'
    },
    bgColor: {
        type: String,
        default: () => '#ffffff14'
    },
},
  emits: ['onClick'],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit
const handleOnClick = () => {
    emits('onClick')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "button_container",
    style: _normalizeStyle({ color: props.textColor, background: props.bgColor }),
    onClick: handleOnClick
  }, [
    (props.icon)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: props.icon,
          alt: ""
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.text), 1)
  ], 4))
}
}

})